module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.closed) ? _c('div', {
    class: _vm.wrapClasses
  }, [(_vm.showIcon) ? _vm._t("icon", [_c('i', {
    class: _vm.iconTypeClass
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.messageClasses
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.desc) ? _c('div', {
    class: _vm.descClasses
  }, [_vm._t("desc")], 2) : _vm._e(), _vm._v(" "), (_vm.closable) ? _c('a', {
    class: _vm.closeClasses,
    on: {
      "click": _vm.onACloseClick
    }
  }, [_vm._t("close", [_c('i', {
    class: _vm.$constants.ICON_CLOSE
  })])], 2) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f5576e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/alert.vue
// module id = 370
// module chunks = 0